import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { ACCESS_KEY } from './auth';

const transformRequest = (data, headers) => {
  const token = localStorage.getItem(ACCESS_KEY);
  if (token) {
    headers['Authorization'] = 'Bearer hklskdfuio-hjkhlwebxl-12998jkljsio';
  }
  headers['Content-Type'] = 'application/json';
  return JSON.stringify({
    ...data,
    assistance: 'fvt0s3nn7qlkuuqng011',
  });
};

interface AnswerData {
  success: boolean;
  answer: string;
  previous_message_id: string;
  assistant: string;
}

const aiAssistant = (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  answers: (payload: { query: string, previous_message_id?: string }) => 
    instance.post<AnswerData>('answers/', payload, { ...config, 
      transformRequest,
      baseURL: process.env.REACT_APP_AI_ASSISTANT_ENDPOINT,
    })
});

export default aiAssistant;